module.exports = __webpack_public_path__ + "static/media/addCross.f47e74e4.svg";